import * as types from '../mutation-types';
import packages from '../../utils/packages';

const state = {
  packages,
  packagesType: null,
  pack: {
    nombre_comercial: '',
    precio_paquete: '',
    vigencia_paquete: ''
  },
  loan: null,
  jsonPackages: [],
  packagesToShow: [],
  roamingCoverage: null,
  roamingType: null
};

const getters = {
  packages: () => state.packages,
  packagesType: () => state.packagesType,
  pack: () => state.pack,
  loan: () => state.loan,
  packagesToShow: () => state.packagesToShow,
  socialPackages: () => state.jsonPackages.filter(item => item.descripcion_comercial === 'Internet' && item.nombre_comercial.match(new RegExp('Redes', 'g'))),
  dataPackages: () => state.jsonPackages.filter(item => item.descripcion_comercial === 'Internet' && item.nombre_comercial.indexOf('Redes', 0) === -1),
  internetPackages: () => state.jsonPackages.filter(item => item.descripcion_comercial === 'Internet'),
  minPackages: () => state.jsonPackages.filter(item => item.descripcion_comercial === 'Minutos'),
  roamingPackages: () => state.jsonPackages.filter(item => item.descripcion_comercial === 'Roaming' && item.descripcion_clase.match(new RegExp(state.roamingCoverage, 'g')) && item.nombre_comercial.indexOf(state.roamingType) > 0),
  smsPackages: () => state.jsonPackages.filter(item => item.descripcion_comercial === 'SMS')
};

const actions = {
  setPackagesType: ({ commit }, packagesType) => {
    commit(types.SET_PACKAGES_TYPE, packagesType);
  },
  setPackagesToShow: ({ commit }, packagesToShow) => {
    commit(types.SET_PACKAGES_TO_SHOW, packagesToShow);
  },
  setPack: ({ commit }, packId) => {
    commit(types.SET_PACK, packId);
  },
  setLoan: ({ commit }, loanDesc) => {
    commit(types.SET_LOAN, loanDesc);
  },
  loadPackages: ({ commit }, clientType) => {
    global.packagesService.getPackages(clientType).then((result) => {
      commit(types.LOADED_PACKAGES, result.data);
    });
  },
  loadLoanPackages: ({ commit }, clientProfile) => {
    if (state.packages.loans.length === 0) {
      global.packagesService.getLoanPackages(clientProfile).then((result) => {
        commit(types.LOADED_LOAN_PACKAGES, result.data);
      });
    }
  },
  setRoamingCoverage: ({ commit }, coverage) => {
    commit(types.SET_ROAMING_COVERAGE, coverage);
  },
  setRoamingType: ({ commit }, packageType) => {
    commit(types.SET_ROAMING_TYPE, packageType);
  }
};

const mutations = {
  [types.SET_PACKAGES_TYPE](_, packagesType) {
    state.packagesType = packagesType;
  },
  [types.SET_PACK](_, packId) {
    state.pack = state.packagesToShow.find(item => item.codigo_paquete === packId);
  },
  [types.SET_LOAN](_, loanDesc) {
    console.log(loanDesc);
    state.loan = state.packages.loans.find(item => item.DESCRIPCION === loanDesc);
  },
  [types.LOADED_PACKAGES](_, jsonPackages) {
    state.jsonPackages = jsonPackages;
  },
  [types.SET_PACKAGES_TO_SHOW](_, packagesToShow) {
    state.packagesToShow = packagesToShow;
  },
  [types.LOADED_LOAN_PACKAGES](_, jsonPackages) {
    state.packages.loans = jsonPackages;
  },
  [types.SET_ROAMING_COVERAGE](_, coverage) {
    state.roamingCoverage = coverage;
  },
  [types.SET_ROAMING_TYPE](_, packageType) {
    state.roamingType = packageType;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/packages.js